import { useEffect } from "react";
import { Platform } from "react-native";
import { useDispatch } from "react-redux";
import MovexGeo from "@movexgeo/react-native-movex";
import { actions as locationActions } from "@reducers/locationReducer";

/**
 * Render-nothing root listener: every movex.geo tracking fix goes into the
 * session-scoped `location` slice, so cache-only readers (useCachedLocation)
 * have a recent position without waking the GPS. Only emits while tracking is
 * running (initMovex); otherwise screens fill the slice with one-shot
 * captures. Same wiring as the partner-db app.
 */
const LocationStreamListener = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (Platform.OS !== "android") return undefined;
    let subscription;
    try {
      subscription = MovexGeo.onLocations((fix) => {
        dispatch(
          locationActions.locationFixReceived({
            latitude: fix.lat,
            longitude: fix.lng,
            accuracy: fix.accuracy_m,
            source: "stream",
          }),
        );
      });
    } catch {
      // Native module unavailable: screens fall back to one-shot captures.
    }
    return () => {
      try {
        subscription?.remove?.();
      } catch {
        // ignore
      }
    };
  }, [dispatch]);
  return null;
};

export default LocationStreamListener;
